import { outfitPieces } from './outfit';
import type { Share, SharedOutfit, SharedPiece, SharedView } from './types';

/** What a link shows; the owner opens the share sheet for one of these. */
export type ShareTarget =
  | { kind: 'list' }
  | { kind: 'board'; id: string; name: string }
  | { kind: 'outfit'; id: string; name: string };

/** The owner's link for this target, if there is one (the newest wins). */
export function findShare(shares: Share[], target: ShareTarget): Share | undefined {
  const matches = shares.filter((s) =>
    target.kind === 'board'
      ? s.board === target.id
      : target.kind === 'outfit'
        ? s.outfit === target.id
        : !s.board && !s.outfit,
  );
  return matches.sort((a, b) => b.created.localeCompare(a.created))[0];
}

export const shareUrl = (origin: string, token: string) => `${origin}/s/${token}`;

export interface SharedSections {
  outfits: { outfit: SharedOutfit; pieces: SharedPiece[] }[];
  singles: SharedPiece[];
}

/** Outfits with their pieces in collage order, then the single pieces. */
export function sharedSections(view: SharedView): SharedSections {
  const byId = new Map(view.items.map((p) => [p.id, p]));
  return {
    outfits: view.outfits.map((outfit) => ({ outfit, pieces: outfitPieces(outfit, view.items) })),
    singles: view.singles.map((id) => byId.get(id)).filter((p): p is SharedPiece => !!p),
  };
}

/** The line under the title of a shared page; honest about who sees reservations. */
export function shareIntro(view: Pick<SharedView, 'owner_name' | 'show_reservations'>): string {
  const who = view.owner_name || 'Wer den Link geteilt hat,';
  const sees = view.show_reservations ? 'sieht, wer was reserviert hat.' : 'sieht nicht, wer was reserviert hat.';
  return `Du willst etwas davon schenken? Reservier es, dann sehen andere, dass es schon jemand besorgt. ${who} ${sees}`;
}
